import * as Yup from "yup";
import { joiEmailSchema } from "../../utils/utils";
const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

export const userProfileValidationSchema = Yup.object({
  firstName: Yup.string()
    .transform((value) => value?.trim())
    .matches(nameRegex, "Only alphabets and single spaces are allowed")
    .min(1, "Min 1 character required")
    .max(50, "Max 50 characters allowed")
    .required("First Name is required"),

  lastName: Yup.string()
    .transform((value) => value?.trim())
    .matches(nameRegex, "Only alphabets and single spaces are allowed")
    .min(1, "Min 1 character required")
    .max(50, "Max 50 characters allowed")
    .required("Last Name is required"),

  email: Yup.string()
    .required("Email Address is required")
    .email("Invalid Email Address")
    .test("joi-email-check", "Invalid email format", function (value) {
      if (!value) return true; // allow empty for now, handled by object-level test
      const { error } = joiEmailSchema.validate(value);
      return !error;
    }),

  profile_photo: Yup.string().optional().nullable(),

  phoneNumber: Yup.string()
    .transform((value) => value?.replace(/\D/g, "").slice(-10))
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Phone Number must be exactly 10 digits"),

  isFuneralDirector: Yup.string()
    .oneOf(["BuyingforSelf/Family", "IamaFuneralDirector"], "Please select a valid option")
    .required("Please select how you want to use Memorial Go"),

  permanentAddress: Yup.object({
    street: Yup.string()
      .trim()
      .max(200, "Max 200 characters allowed")
      .when("$enablePermanentAddress", {
        is: true,
        then: (s) => s.required("Street is required"),
        otherwise: (s) => s.notRequired(),
      }),
    city: Yup.string().when("$enablePermanentAddress", {
      is: true,
      then: (s) => s.required("City is required"),
      otherwise: (s) => s.notRequired(),
    }),
    state: Yup.string().when("$enablePermanentAddress", {
      is: true,
      then: (s) => s.required("State is required"),
      otherwise: (s) => s.notRequired(),
    }),
    country: Yup.string().when("$enablePermanentAddress", {
      is: true,
      then: (s) => s.required("Country is required"),
      otherwise: (s) => s.notRequired(),
    }),
    zipcode: Yup.string().when("$enablePermanentAddress", {
      is: true,
      then: (s) => s.required("Zipcode is required"),
      otherwise: (s) => s.notRequired(),
    }),
  }),

  billingAddress: Yup.object({
    street: Yup.string()
      .trim()
      .max(200, "Max 200 characters allowed")
      .when(["$enableBillingAddress", "$billingSameAsPermanent"], {
        is: (enable, same) => enable && !same,
        then: (s) => s.required("Street is required"),
        otherwise: (s) => s.notRequired(),
      }),
    city: Yup.string().when(
      ["$enableBillingAddress", "$billingSameAsPermanent"],
      {
        is: (enable, same) => enable && !same,
        then: (s) => s.required("City is required"),
        otherwise: (s) => s.notRequired(),
      }
    ),
    state: Yup.string().when(
      ["$enableBillingAddress", "$billingSameAsPermanent"],
      {
        is: (enable, same) => enable && !same,
        then: (s) => s.required("State is required"),
        otherwise: (s) => s.notRequired(),
      }
    ),
    country: Yup.string().when(
      ["$enableBillingAddress", "$billingSameAsPermanent"],
      {
        is: (enable, same) => enable && !same,
        then: (s) => s.required("Country is required"),
        otherwise: (s) => s.notRequired(),
      }
    ),
    zipcode: Yup.string().when(
      ["$enableBillingAddress", "$billingSameAsPermanent"],
      {
        is: (enable, same) => enable && !same,
        then: (s) => s.required("Zipcode is required"),
        otherwise: (s) => s.notRequired(),
      }
    ),
  }),
});
